import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getParameterRequest } from "../../redux/action";
import { getParams } from "../../redux/selector";
import "./FormGuard.css";

function FormGuardContent({ handleSubmit, formId, errMsg }) {
    const { t, i18n } = useTranslation();
    const [loadedTemp, setLoadedTemp] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (!loadedTemp) {
            dispatch(getParameterRequest(formId));
            setLoadedTemp(true);
        }
    }, [formId]);
    return (
        <>
            <div className="FormGuard">
                <form onSubmit={handleSubmit}>
                    <label className="FormGuardLabel" htmlFor="password">
                        {t(`${formId}.formGuard.title`)}
                    </label>
                    <input
                        className="FormGuardPassword"
                        name="password"
                        type="password"
                        id="password"
                    />
                    <div className="FormGuardErrorMsg">{errMsg}</div>
                    <input
                        className="FormGuardSubmit"
                        type="submit"
                        value={t(`${formId}.formGuard.submit`)}
                    />
                </form>
            </div>
        </>
    );
}

function FormGuard({ children, formId }) {
    const [inputPW, setInputPW] = useState("");
    const params = useSelector(getParams());
    const { t, i18n } = useTranslation();
    let errMsg = "";
    function handleSubmit(event) {
        event.preventDefault();
        setInputPW(event.target.password.value);
    }
    if (inputPW === params.password) {
        return children;
    } else {
        if (inputPW != "") {
            errMsg = t(`${formId}.formGuard.passwordErr`);
        }
        return (
            <FormGuardContent
                handleSubmit={handleSubmit}
                formId={formId}
                errMsg={errMsg}
            />
        );
    }
}

export default FormGuard;
